import React, { useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { FaSave, FaAngleLeft } from 'react-icons/fa';
import { API } from 'aws-amplify';
import { useToasts } from 'react-toast-notifications';

const CustomProfile = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const { addToast } = useToasts();
  const [selProfile, setSelProfile] = useState({});
  const [user, setUser] = useState({
    name: '',
    username: '',
    admin: '',
    contractor: '',
    status: '',
    confirmed: '',
    enabled: '',
    assets: [],
    settings: [],
  });

  const [nameError, setNameError] = useState(''); // For error message

  const params = {
    headers: {
      'x-api-key': process.env.REACT_APP_API_KEY,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
  };

  useEffect(() => {
    // setSelProfile(initialPermissions.values); // Load initial permissions
    const globalPermission = async () => {
      const global_perm = await API.get('global_custom_permission_list', '/', params);
      console.log(global_perm[0].customProfile);
      setSelProfile(global_perm[0].customProfile);
    };
    globalPermission();
  }, []);

  // Handle checkbox change
  const handleCheckboxChange = (category, permission) => {
    setSelProfile((prevProfile) => ({
      ...prevProfile,
      [category]: {
        ...prevProfile[category],
        [permission]: {
          ...prevProfile[category][permission],
          checked: !prevProfile[category][permission].checked, // Toggle checked state
        },
      },
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    // Check if profile name is empty
    if (user.name.trim() === '') {
      setNameError('Profile Name is required');
      setIsLoading(false);
      return;
    } else {
      setNameError('');
    }

    // Proceed with submission if the name is filled
    selProfile.profile_name = user.name;
    try {
      await API.post('custom_permissions', '/', {
        body: {
          customProfile: selProfile,
        },
        headers: {
          'x-api-key': process.env.REACT_APP_API_KEY,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      });

      props.history.push('/custom_profile/');
      addToast('Saved successfully', { appearance: 'success' });
    } catch (error) {
      addToast('Error saving profile', { appearance: 'error' });
    }

    setIsLoading(false);
  };

  return !isLoading ? (
    <div className="DeviceList">
      <div className="col-md-12">
        <form key="form" onSubmit={handleSubmit}>
        <div className="row header pb-1">
            <div className="col-md-6">Custom Profile</div>
            <div className="col-md-6 text-right d-flex justify-content-end">
              <Button variant="secondary" className="mr-1 text-nowrap" onClick={() => { props.history.goBack() }}>
                Back &nbsp;
                <FaAngleLeft />
              </Button>
              <Button variant="success" className="text-nowrap" type="submit">
                Save &nbsp;
                <FaSave />
              </Button>
            </div>
          </div>

          {/* <div className="row header">
            <div className="col-md-11">Custom Profile</div>
            <Button variant="success" className="mr-8 text-nowrap" type="submit">
              Save &nbsp;
              <FaSave />
            </Button>
          </div> */}
          <div className="row div-content">
            <div className="pl-5">
              <Form.Group controlId="profile">
                <Form.Group controlId="name">
                  <Form.Label>Profile Name</Form.Label>
                  <Form.Control
                    autoFocus
                    type="input"
                    value={user.name}
                    onChange={(e) => setUser({ ...user, name: e.target.value })}
                    isInvalid={!!nameError} // Apply error style if error exists
                  />
                  {nameError && (
                    <Form.Control.Feedback type="invalid">
                      {nameError}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              </Form.Group>
            </div>
            <div className="col-md-12">
              <div className="p-3">
                <div className="col-md-12">
                  <div className="row px-3">
                    <div className="col-md-12">
                      <div className="row">
                        {Object.keys(selProfile).map((category, i) => (
                          <div key={`category-${i}`} className="col-md-3">
                            <h4>{category}</h4>
                            <div>
                              {Object.keys(selProfile[category]).map(
                                (permission, j) => (
                                  <div key={`permission-${category}-${j}`}>
                                    <Form.Check
                                      type="checkbox"
                                      id={permission}
                                      label={selProfile[category][permission].label}
                                      checked={
                                        selProfile[category][permission].checked
                                      }
                                      onChange={() =>
                                        handleCheckboxChange(category, permission)
                                      }
                                    />
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  ) : (
    ''
  );
};

export default CustomProfile;
